import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { Seo } from "@/components/Seo";

export default function AdvertiseCancel() {
  return (
    <main data-testid="advertise-cancel" className="pt-16 md:pt-20 min-h-screen bg-[#F9F8F6]">
      <Seo title="Payment cancelled · CPH Highlights" description="Advertising purchase cancelled" path="/advertise/cancel" noindex />
      <div className="max-w-[720px] mx-auto px-5 py-24 text-center">
        <XCircle className="mx-auto text-[#DF3226]" size={48} />
        <h1 className="font-display font-900 tracking-tighter text-4xl mt-6">Payment cancelled</h1>
        <p className="font-body text-base text-black/70 mt-4 max-w-md mx-auto">
          No worries — nothing was charged. Your details weren&apos;t submitted. Whenever you&apos;re ready, pick a
          package and try again.
        </p>
        <Link
          to="/advertise#packages"
          data-testid="cancel-retry"
          className="inline-flex items-center gap-2 mt-8 font-body font-800 bg-[#DF3226] text-white px-7 py-3.5 rounded-full hover:-translate-y-0.5 transition-all"
        >
          <ArrowLeft size={16} /> Back to packages
        </Link>
      </div>
    </main>
  );
}
